<template>
    <div :class="{'quota-sidebar' : inSidebar}">
      <div class="card">
          <div class="row">
              <div class="col-sm-12">
                  <h4 v-if="!inSidebar" class="pull-left">Compute</h4> <fQuotaLinks resourceName="instances" addedStyles="pull-right" v-if="quota" />
              </div>
            </div>
            <div v-for="(quotaRegion, index) in quota" :key="index"  v-if="quota && quota[0].instances">
                <p v-if="!inSidebar" class="mb-1 mt-3"><strong>{{ quotaRegion.region }}</strong></p>
                <div class="quota" :class="{'row' : !inSidebar}">
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>Instances: <strong class="pull-right">{{ quotaRegion.instances.in_use.toFixed(0) }} / <span v-if="quotaRegion.instances.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.instances.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.instances.in_use" :max="quotaRegion.instances.limit" :class="{danger: (quotaRegion.instances.in_use / quotaRegion.instances.limit * 100).toFixed(2) > 79, error: (quotaRegion.instances.in_use / quotaRegion.instances.limit * 100).toFixed(2) > 99}"></b-progress>
                        <small v-if="(quotaRegion.instances.in_use / quotaRegion.instances.limit * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quotaRegion.</small>
                    </div>
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>VCPUs: <strong class="pull-right">{{ quotaRegion.cores.in_use }} / <span v-if="quotaRegion.cores.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.cores.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.cores.in_use" :max="quotaRegion.cores.limit" :class="{danger: (quotaRegion.cores.in_use / quotaRegion.cores.limit * 100).toFixed(2) > 79, error: (quotaRegion.cores.in_use / quotaRegion.cores.limit * 100).toFixed(2) > 99 }"></b-progress>
                        <small v-if="(quotaRegion.cores.in_use / quotaRegion.cores.limit * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quotaRegion.</small>
                    </div>
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>Memory (MB): <strong class="pull-right">{{ quotaRegion.ram.in_use.toFixed(0) }} / <span v-if="quotaRegion.ram.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.ram.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.ram.in_use" :max="quotaRegion.ram.limit" :class="{danger: (quotaRegion.ram.in_use / quotaRegion.ram.limit * 100).toFixed(2) > 79, error: (quotaRegion.ram.in_use / quotaRegion.ram.limit * 100).toFixed(2) > 99 }"></b-progress>
                        <small v-if="(quotaRegion.ram.in_use / quotaRegion.ram.limit * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quotaRegion.</small>
                    </div>
                </div>
            </div>
            <svg-spinner v-else class="spinner"/>
        </div>
        <div class="card">
            <div class="row">
              <div class="col-sm-12">
                  <h4 v-if="!inSidebar" class="pull-left">Volumes </h4> <fQuotaLinks resourceName="volumes" addedStyles="pull-right" v-if="quotaVolume" />
              </div>
            </div>
            <div v-for="(quotaRegion, index) in quotaVolume" :key="'quotaVolume' + index"  v-if="quota && quota[0].instances">
            <p v-if="!inSidebar" class="mb-1 mt-3"><strong>{{ quotaRegion.region }}</strong></p>
                <div class="quota" v-if="quotaVolume" :class="{'row' : !inSidebar}">
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>Volumes: <strong class="pull-right">{{ quotaRegion.volumes.in_use.toFixed(0) }} / <span v-if="quotaRegion.volumes.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.volumes.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.volumes.in_use" :max="quotaRegion.volumes.limit" :class="{danger: (quotaRegion.volumes.in_use / quotaRegion.volumes.limit * 100).toFixed(2) > 79, error: (quotaRegion.volumes.in_use / quotaRegion.volumes.limit * 100).toFixed(2) > 99}"></b-progress>
                        <small v-if="(quotaRegion.volumes.in_use / quotaRegion.volumes.limit * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quota.</small>
                    </div>
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>Volume Storage: <strong class="pull-right">{{ quotaRegion.gigabytes.in_use.toFixed(0) }} / <span v-if="quotaRegion.gigabytes.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.gigabytes.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.gigabytes.in_use" :max="quotaRegion.gigabytes.limit" :class="{danger: (quotaRegion.gigabytes.in_use / quotaRegion.gigabytes.limit  * 100).toFixed(2) > 79, error: (quotaRegion.gigabytes.in_use / quotaRegion.gigabytes.limit  * 100).toFixed(2) > 99}"></b-progress>
                        <small v-if="(quotaRegion.gigabytes.in_use / quotaRegion.gigabytes.limit  * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quota.</small>
                    </div>
                    <div class="card" :class="{'col-md-4' : !inSidebar}">
                        <span>Snapshots: <strong class="pull-right">{{ quotaRegion.snapshots.in_use.toFixed(0) }} / <span v-if="quotaRegion.snapshots.limit === -1">Unlimited</span><span v-else>{{ quotaRegion.snapshots.limit }}</span></strong></span>
                        <b-progress :value="quotaRegion.snapshots.in_use" :max="quotaRegion.snapshots.limit" :class="{danger: (quotaRegion.snapshots.in_use / quotaRegion.snapshots.limit  * 100).toFixed(2) > 79, error: (quotaRegion.snapshots.in_use / quotaRegion.snapshots.limit  * 100).toFixed(2) > 99}"></b-progress>
                        <small v-if="(quotaRegion.snapshots.in_use / quotaRegion.snapshots.limit  * 100).toFixed(2) > 79">Quota almost exceeded. Increase  your quota.</small>
                    </div>
                </div>
            </div>
            <svg-spinner v-else class="spinner"/>
        </div>
    </div>
</template>

<script>
const svgSpinner = () => import('@/components/svg/svg-spinner');
import fQuotaLinks from '@/components/f-quota-links';

export default {
    props: ['inSidebar'],

    computed: {
          quota() {
              return this.$store.state.instance.quota;
          },

          quotaVolume() {
              return this.$store.state.volumev3.quota;
          },

          networkingQuota() {
              return false;
              // return this.$store.state.volumev3.quota;
          },
    },

    created() {
        this.fetchQuotas();
    },

    components: {
        svgSpinner,
        fQuotaLinks,
    }
}
</script>
<style>
.progress {
    background: #e0f3f8;
}

.progress-bar {
    background-color: #25b3b8 !important;
}

.progress.danger .progress-bar {
    background: linear-gradient(90deg, #25b3b8 80%, orange 100%);
}

.progress.error .progress-bar {
    background: linear-gradient(90deg, #25b3b8 80%, rgba(255,104,0,1) 95%, rgba(255,0,0,1) 100%);
}
</style>
